<template>
  <div>
    <div v-for="tabsData in tabsData">
      <div v-if="tabsData.label === 'Appliances'" >
        <div class="radio_container" v-if="calculatorData.isTata">
            <el-radio v-model="radio" value="Add Critical Load & Backup Hours" @change="handleRadioChange">Add Critical Load & Backup Hours</el-radio>
            <el-radio v-model="radio" value="Add Appliances" @change="handleRadioChange">
              Add Appliances 
            </el-radio> 
        </div>
        <div class="gridContainer" v-if="calculatorData.isTata && radio === 'Add Critical Load & Backup Hours'">
          <div class="flexColumn">
            <label class="input_label">Enter Critical Load<span style="color: red"> *</span></label>
            <p class="criticalLoadUnit">kW</p>
            <input type="number" placeholder=""  v-model="criticalLoad" class="input_fields criticalLoadInput" @change="callFinancialApi()"/>
          </div>
          <div class="flexColumn">
            <label class="input_label">Backup Hours<span style="color: red"> *</span></label>
            <input type="number" placeholder="" v-model="backupHours" class="input_fields" @change="callFinancialApi()"/>
            <p v-if="backupHours > 7" class="error_field">Back up hours can't be greater than 7</p>
          </div>
          <div class="flexColumn">
            <label class="input_label">No. of AC<span style="color: red"> *</span></label>
            <el-select v-model="noOfAC" placeholder="Select" @change="callFinancialApi()">
              <el-option
                v-for="item in acList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
        </div>
        <p class="appliances_title" v-if="!calculatorData.isTata || (calculatorData.isTata && radio === 'Add Appliances')">Appliances</p>

        <hr class="hrClass" v-if="!calculatorData.isTata || (calculatorData.isTata && radio === 'Add Appliances')"/>

        <div class="main_appliances_container" v-if="!calculatorData.isTata || (calculatorData.isTata && radio === 'Add Appliances')">
          <div class="appliances_details_container">
            <div class="appliances_details">
              Total Load:
              <span class="appliances_values"
                >{{ totalLoad }} W</span
              >
            </div>
          </div>

          <div class="appliances_table" v-if="!isMobile">
            <tableView :tableData="tableData">
              <template #name="{ row, column }">
                <el-select
                  v-model="row[column.id]"
                  placeholder="Select Appliances"
                  v-if="row.is_new"
                  @change="handleAppliancesSelect(row, column)"
                >
                  <el-option
                    v-for="item in appliancesList"
                    :key="item.label"
                    :label="item.label"
                    :value="item.label"
                  >
                  </el-option>
                </el-select>

                <p class="appliances_names" v-if="!row.is_new">
                  {{ row[column.id] }}
                </p>
              </template>

              <template #textbox="{ row, column }">
                <div class="watt_appliances">
                  <input
                    placeholder="watt"
                    type="number"
                    v-model="row[column.id]"
                    @input="handleAppliancesWatt(row, column)"
                    class="appliances_watt_value"
                    @blur.prevent="recalculateTableData(row)"
                  />
                </div>
              </template>

              <template #number_input="{ row, column }">
                <div class="appliances_number_input">
                  <div class="input_number">
                    <img
                      :src="
                        handleAppliancesDecrementButton(row, column, 'decrease')
                      "
                      alt="image"
                      @click="handleAppliancesClicks(row, column, 'decrease')"
                      :class="
                        handleAppliancesButtonStyles(row, column, 'decrease')
                      "
                    />
                    <div class="appliances_input">
                      <input
                        type="number"
                        v-model="row[column.id]"
                        class="appliances_input_value"
                        @input="handleAppliancesButtonInput(row, column)"
                        @blur.prevent="handleAppliancesButtonBlur(row, column)"
                      />
                    </div>
                    <img
                      :src="
                        handleAppliancesIncrementButton(row, column, 'increase')
                      "
                      alt="image"
                      @click="handleAppliancesClicks(row, column, 'increase')"
                      :class="
                        handleAppliancesButtonStyles(row, column, 'increase')
                      "
                    />
                  </div>
                </div>
              </template>

              <template #edit_application="{ row, column }">
                <div :class="appliancesContainerStyles(row, column)">
                  <!-- <div v-if="row.is_new" @click="confirmDataTable(row, column)">
                    <p :style="handleTickColor(row, column)">✓</p>
                  </div> -->
                  <img
                    src="../../assets/deleteIcon.svg"
                    alt=""
                    style="cursor: pointer"
                    @click="handleTableData(row, column)"
                  />
                </div>
              </template>
            </tableView>
          </div>

          <div v-else class="collapse_container">
            <el-collapse v-model="activeNames">
              <el-collapse-item v-for="(row,index) in tableData" :key="row.id || index" :name="row.id || index">
    <template #title>
      <div style="display: flex;justify-content: space-between;align-items: center;width: 100%;padding: 16px;">
      <p v-if="row.is_new" style="font-weight: 700;">{{ 'Add New Appliance' }}</p>
        <p v-else  style="font-weight: 700;">{{ row.name }}</p>
        <p class="btn_container" >
          <!-- <div v-if="row.is_new" @click="confirmDataTable(row, column)">
            <p :style="handleTickColor(row, column)">✓</p>
          </div> -->
          <img
            src="../../assets/deleteIcon.svg"
            alt=""
            style="cursor: pointer;padding-left: 16px;"
            @click="handleTableData(row, column)"
          />
        </p>
    </div>
    </template>

<div class="collaps-content" v-for="(column,index) in applianceLabel" :key="index">

  <div class="collaps-content-label" v-if="column.type!=='name'">{{ column.title }}</div>
  <div :class=" column.type=='name'?'collaps-content-name' :'collaps-content-value'">
    <div v-if="column.type=='name'">
      <el-select
                  v-model="row[column.id]"
                  placeholder="Select Appliances"
                  v-if="row.is_new"
                  @change="handleAppliancesSelect(row, column)"
                >
                  <el-option
                    v-for="item in appliancesList"
                    :key="item.label"
                    :label="item.label"
                    :value="item.label"
                  >
                  </el-option>
                </el-select>
              </div>
                <div class="watt_appliances" v-if="column.type=='textbox'" style="margin-right: 32px;">
                  <input
                    placeholder="watt"
                    type="number"
                    v-model="row[column.id]"
                    @input="handleAppliancesWatt(row, column)"
                    class="appliances_watt_value"
                    @blur.prevent="recalculateTableData(row)"
                  />
                </div>

         
                <div class="appliances_number_input" v-if="column.type=='number_input'">
                  <div class="input_number">
                    <img
                      :src="
                        handleAppliancesDecrementButton(row, column, 'decrease')
                      "
                      alt="image"
                      @click="handleAppliancesClicks(row, column, 'decrease')"
                      :class="
                        handleAppliancesButtonStyles(row, column, 'decrease')
                      "
                    />
                    <div class="appliances_input">
                      <input
                        type="number"
                        v-model="row[column.id]"
                        class="appliances_input_value"
                        @input="handleAppliancesButtonInput(row, column)"
                        @blur.prevent="handleAppliancesButtonBlur(row, column)"
                      />
                    </div>
                    <img
                      :src="
                        handleAppliancesIncrementButton(row, column, 'increase')
                      "
                      alt="image"
                      @click="handleAppliancesClicks(row, column, 'increase')"
                      :class="
                        handleAppliancesButtonStyles(row, column, 'increase')
                      "
                    />
                  </div>
                </div>

  </div>

</div>
  </el-collapse-item>

            </el-collapse>
          </div>
          <p v-if="tableData.length === 0" style="color: red;">Add appliances to get off-grid system details</p>

          <div class="appliances_add_button">
            <button
              class="appliances_button"
              @click="addAppliancesData"
              :style="handleAppliancesButtonColor()"
            >
              <span style="font-size: x-large">+</span> Add New Appliances
            </button>
          </div>
        </div>
      </div>
      <div
      v-if="(tabsData.label === 'Our Recommendation' || (tabsData.label === 'Your System Estimate' && calculatorData.isTata)) && 
        (calculatorData.selected_grid === 'on_grid' || 
        (calculatorData.selected_grid === 'off_grid' && !calculatorData.isTata && ((tableData.some(item => item.name)))) ||
        (calculatorData.selected_grid === 'off_grid' && radio === 'Add Appliances' && (tableData.reduce((sum, item) => sum + (parseInt(item.quantity) || 0), 0) > 0)) ||
        (calculatorData.selected_grid === 'off_grid' && radio === 'Add Critical Load & Backup Hours' && criticalLoadAndBackupHoursApiCalled))">
        <Detailed
          :cardData="tabsData"
          :heading="tabsData.label === 'Our Recommendation' ? 'Our recommendation' : 'Your System Estimate'"
          @updateCalculatorsData="updateCalculatorsData"
        />
        <div style="margin-bottom: 30px" v-if="tabsData.label === 'Our Recommendation'">
          <p class="info_note">
            *Above plant size is only indicative and derived based on your
            inputs.
          </p>
          <p class="info_note">
            The actual plant size capacity will be based on available rooftop
            area.
          </p>
          <p class="info_note">
            If the area available is more than the recommended area required,
            higher capacities can be installed and vice-versa.
          </p>
        </div>
      </div>

      <div v-if="showContent && 
        (calculatorData.selected_grid === 'on_grid' || 
        (calculatorData.selected_grid === 'off_grid' && !calculatorData.isTata && ((tableData.some(item => item.name)))) ||
        (calculatorData.selected_grid === 'off_grid' && radio === 'Add Appliances' && (tableData.reduce((sum, item) => sum + (parseInt(item.quantity) || 0), 0) > 0)) ||
        (calculatorData.selected_grid === 'off_grid' && radio === 'Add Critical Load & Backup Hours' && criticalLoadAndBackupHoursApiCalled))">
        <div v-if="(!calculatorData.isTata && tabsData.label === 'Savings and Payback from Solar') || (calculatorData.isTata && tabsData.label === 'Savings and Payback from Solar' && !calculatorData.showRoiButton)">
          <Detailed :cardData="tabsData" :heading="'Our recommendation'" />
        </div>

        <div v-if="(!calculatorData.isTata && tabsData.label === 'Title') || (calculatorData.isTata && tabsData.label === 'Title' && !calculatorData.showRoiButton)">
          <Detailed :cardData="tabsData" :heading="'Our recommendation'" />
        </div>

        <div v-if="(!calculatorData.isTata && tabsData.label === 'Configuration/Item Description') || (calculatorData.isTata && tabsData.label === 'Configuration/Item Description' && !calculatorData.showRoiButton)">
          <Detailed
            :cardData="tabsData"
            :heading="'Our recommendation'"
            :info_style="'width'"
          />
        </div>

        <div v-if="(!calculatorData.isTata && tabsData.question_type === 'grey_card') || (calculatorData.isTata && tabsData.question_type === 'grey_card' && !calculatorData.showRoiButton)">
          <PriceContainer :data="tabsData" />
        </div>

        <Contribution
          :newData="tabsData"
          v-if="(!calculatorData.isTata && tabsData.question_type === 'grey_image_card') || (calculatorData.isTata && tabsData.question_type === 'grey_image_card' && !calculatorData.showRoiButton)"
        />

        <div v-if="tabsData.question_type === 'logo' && calculatorData.isTata && !calculatorData.showRoiButton">
          <LogoCard />
        </div>
      </div>
      <div v-if="tabsData.question_type === 'blue_card' && calculatorData.isTata && calculatorData.showRoiButton">
        <BlueCard
          :data="tabsData"
          @tabsChanges="tabsChanges"
          @updateData="updateData()"
        />
      </div>
    </div>

    <button class="blueButton" v-if="calculatorData.isTata && calculatorData.showRoiButton" @click="handleRoi">
      Check your ROI, Savings & EMI
    </button>

    <div class="details_card" v-if="(showContent && calculatorData.contact_no && !calculatorData.isTata) || (calculatorData.isTata && calculatorData.contact_no && !calculatorData.showRoiButton && showContent)">
      <div class="cardWrapper">
        <p class="contact_info">
          If you have any queries, please feel free to call us on this toll-free
          number.
        </p>
        <div class="contact_card">
          <div class="contact_wrapper">
            <div class="contact_left">
              <img src="../../assets/phone.svg" alt="" v-if="calculatorData.isTata"/>
              <img src="../../assets/Telephone.svg" alt="" v-else/>
            </div>
            <div class="contact_right">
              <p class="contact_details" v-if="calculatorData.isTata">CALL US (TOLL FREE)</p>
              <p class="contact_details2" v-else>CALL US</p>
              <p :class="calculatorData.isTata?'contact_details':'contact_details2'">{{ calculatorData.contact_no }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <basicInfoPopup
    v-if="dialogVisible"
      :dialogVisible="dialogVisible"
      :basicInfoData="basicInfoData"
      :calculatorData="calculatorData"
      @verificationDialog="toggleOtpPopup"
      @verifyDetails="verifyDetails"
      :isGenerate="false"
      @update:dialogVisible="newValue => dialogVisible = newValue"
      @generateResults="emits('calculateData')"
    />
    <otpPopup 
    v-if="verificationDialog" 
    :verificationDialog="verificationDialog" 
    @update:verificationDialog="newValue => verificationDialog = newValue" 
    @showContent="handleShowContent" 
    @isCalculateRoi="handleIsCalculateRoi"
    @generate="generate = newValue => generate = newValue"
    />
    <div class="loading_popup">
      <el-dialog
        v-model="loading"
        width="30%"
        :top="'45vh'"
        :close-on-click-modal="false"
      >
        <div
          style="
            display: flex;
            align-items: center;
            flex-direction: column;
            padding-bottom: 10px;
          "
        >
          <img
            class="loading_gif"
            style="width: 70px; height: 70px"
            src="../../assets/giphy.gif"
          />
          <p>Sending OTP To Your Mobile Number</p>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, watch, defineExpose, onBeforeUnmount, computed } from "vue";
import debounce from "debounce";
import basicInfoPopup from "./basicInfoPopup.vue";
import Graph from "../../graph.vue";
import Contribution from "./Contribution.vue";
import { v4 } from "uuid";
import API from "../../../../services/api";
import Detailed from "./Detailed.vue";
import DetailtedGraphs from "./DetailtedGraphs.vue";
import BlueCard from "./BlueCard.vue";
import PriceContainer from "./PriceContainer.vue";
import { uploadFileToBlob } from "@/utils.js";
import { sasToken } from "../../../../services/api/index";
import { storageAccountName } from "../../../../services/api/index";
import LogoCard from "./LogoCard.vue";
import tableView from "./tableView.vue";
import { solarCalculatorStore } from "../../../store/solarCalculator";
import { column } from "element-plus/es/components/table-v2/src/common";
import addButton from "../../assets/addButton.svg";
import addDisabled from "../../assets/add_disable.svg";
import subsButton from "../../assets/substract.svg";
import subsDisabled from "../../assets/substract_disabled.svg";
import { TEMPLATE_ID_FOR_TATA, TEMPLATE_ID_FOR_DIFF_ORG } from "../../../../constants";
import otpPopup from "./otpPopup.vue";


const props = defineProps({
  tabsData: Array,
  showContent: Boolean,
  isCalculateRoi: Boolean,
});

const uploadUrl = `https://${storageAccountName}.blob.core.windows.net/?${sasToken}`;

const emits = defineEmits(["tabChanges, calculateData"]);
const otpProps = reactive({
  length: 4,
});
const store = solarCalculatorStore();
const calculatorData = store.calculatorData;

const newAppliancesAdded = ref(false);
const activeNames = ref([]); // To track which collapse items are expanded
const optArray = ref([]);
const data = ref({});
const loading = ref(false);
const uploadedFile = ref({});
const name_error = ref(false);
const email_error = ref(false);
const mob_no_error = ref(false);
const imageUrl = ref("");
const fileInput = ref(null);
const shouldCallFinancialApi = ref(false);
const outageHoursApiCalling = ref(false);
// const morning_outage = ref(calculatorData.morning_outage_hours);
// const evening_outage = ref(calculatorData.night_outage_hours);
const verificationDialog = ref(false);
const dialogVisible = ref(false);
// const showContent = ref(false);
// const isCalculateRoi = ref(true);
const eveningOutageHours = ref(null);
const pinContainer = ref();
const readAgreement = ref(false);
const totalAppliancesConsumptionData = ref(0.22);
const totalBackupPower = ref(0);
const totalLoad = ref(0);
const totalBackupEnergy = ref(0);
const add = ref(addButton);
const subs = ref(subsButton);
const addDisabledImg = ref(addDisabled);
const subsDisabledImg = ref(subsDisabled);
const timer = ref(0);
const screenWidth=ref(window.innerWidth);
const basicInfoData = ref({});
const radio = ref('Add Critical Load & Backup Hours');
const criticalLoad = ref();
const backupHours = ref();
const criticalLoadAndBackupHoursApiCalled = ref(false);
const acList = ref([
  { value: 0, label: '0' },
  { value: 1, label: '1' },
  { value: 2, label: '2' },
  { value: 3, label: '3' },
  { value: 4, label: '4' },
  { value: 5, label: '5' },
]);
const noOfAC = ref();


const toggleOtpPopup = (value) => {
  verificationDialog.value = value;
};

const handleShowContent = (value) => {
  showContent.value = value;
};

const handleIsCalculateRoi = (value) => {
  isCalculateRoi.value = value;
};

const applianceLabel=ref([

  {
    id: "name",
    title: "Application Name",
    type: "name",
    width: 200,
  },
  {
    id: "quantity",
    title: "Quantity",
    type: "number_input",
    width: 220,
  },
  {
    id: "default_load_kw",
    title: "Watt (w)",
    type: "textbox",
    width: 170,
  },
  {
    id: "operating_hour_morning",
    title: "Working Hours (10AM-3PM)",
    type: "number_input",
    width: 200,
  },

  {
    id: "operating_hour_evening",
    title: "Working Hours (3PM-10AM)",
    type: "number_input",
    width: 200,
  },

  {
    id: "edit_application",
    title: "",
    type: "edit_application",
    width: 90,
  },
])

const handleAppliancesButtonColor = () => {
  if (newAppliancesAdded.value === false) {
    return {
      color: "#184d93",
    };
  } else {
    return {
      color: "#ccc",
    };
  }
};

const tableData = ref([

  {
    id: 1,
    name: "Lights(CFL)",
    quantity: calculatorData.isTata ? 0 : 1,
    default_load_kw: 30,
    operating_hour_morning: 1,
    operating_hour_evening: 1,
    is_new: false,
  },
  {
    id: 2,
    name: "Lights(LED)",
    quantity: calculatorData.isTata ? 0 : 1,
    default_load_kw: 10,
    operating_hour_morning: 1,
    operating_hour_evening: 1,
    is_new: false,
  },
  {
    id: 3,
    name: "Fan",
    quantity: calculatorData.isTata ? 0 : 1,
    default_load_kw: 60,
    operating_hour_morning: 1,
    operating_hour_evening: 1,
    is_new: false,
  },
  {
    id: 4,
    name: "Television",
    quantity: calculatorData.isTata ? 0 : 1,
    default_load_kw: 120,
    operating_hour_morning: 1,
    operating_hour_evening: 1,
    is_new: false,
  },
]);
const appliancesList = ref([
  { label: "Desktop/Laptop" },
  { label: "Mixer/Grinder" },
  { label: "Refrigerator" },
  { label: "Air Conditioner" },
  { label: "1HP Pump" },
  { label: "Iron" },
  { label: "Washing Machine" },
]);

const applicationListValueSelect = ref([
  {
    name: "Lights(CFL)",
    quantity: 1,
    default_load_kw: 30,
    operating_hour_morning: 1,
    operating_hour_evening: 1,
  },
  {
    name: "Lights(LED)",
    quantity: 1,
    default_load_kw: 10,
    operating_hour_morning: 1,
    operating_hour_evening: 1,
  },
  {
    name: "Fan",
    quantity: 1,
    default_load_kw: 60,
    operating_hour_morning: 1,
    operating_hour_evening: 1,
  },
  {
    name: "Television",
    quantity: 1,
    default_load_kw: 120,
    operating_hour_morning: 1,
    operating_hour_evening: 1,
  },
  {
    name: "Desktop/Laptop",
    quantity: 1,
    default_load_kw: 200,
    operating_hour_morning: 1,
    operating_hour_evening: 1,
  },
  {
    name: "Mixer/Grinder",
    quantity: 1,
    default_load_kw: 300,
    operating_hour_morning: 1,
    operating_hour_evening: 1,
  },
  {
    name: "Refrigerator",
    quantity: 1,
    default_load_kw: 350,
    operating_hour_morning: 1,
    operating_hour_evening: 1,
  },
  {
    name: "Air Conditioner",
    quantity: 1,
    default_load_kw: 1500,
    operating_hour_morning: 1,
    operating_hour_evening: 1,
  },
  {
    name: "1HP Pump",
    quantity: 1,
    default_load_kw: 750,
    operating_hour_morning: 1,
    operating_hour_evening: 1,
  },
  {
    name: "Iron",
    quantity: 1,
    default_load_kw: 1000,
    operating_hour_morning: 1,
    operating_hour_evening: 1,
  },
  {
    name: "Washing Machine",
    quantity: 1,
    default_load_kw: 750,
    operating_hour_morning: 1,
    operating_hour_evening: 1,
  },
]);

const leadCaptureTemplate = ref({});

const video_img = "https://dev.arka360.com/assets/multimedia-626a4f3b.svg";

const setTimerValue = () => {
  timer.value = 60;
  const interval = setInterval(() => {
    if (timer.value > 0) {
      timer.value--;
    } else {
      clearInterval(interval);
    }
  }, 1000);
};

const tabsChanges = debounce(() => {
  emits("tabChanges");
}, 1000);

const handleTickColor = (row, column) => {
  if (row.name === "") {
    return {
      color: "#ccc",
      fontSize: "larger",
      cursor: "pointer",
    };
  } else {
    return {
      color: "green",
      fontSize: "larger",
      cursor: "pointer",
    };
  }
};

const handleRadioChange = (value) => {
    if(value === 'Add Critical Load & Backup Hours'){
      callFinancialApi()
    } else if (value === 'Add Appliances') {
        totalAppliancesConsumption();
        backupPower();
        workingHours();
        updateCalculatorsData()
    }
};

const callFinancialApi = () => {
  if(criticalLoad.value > 0 && (backupHours.value >= 0 && backupHours.value <= 7 && backupHours.value !== '') && (noOfAC.value === 0 || noOfAC.value > 0)){
    if(noOfAC.value > 0){
      store.UPDATE_CALCULATOR_DATA(true, "ac");
    }
    criticalLoadAndBackupHoursApiCalled.value = true;
    store.UPDATE_CALCULATOR_DATA(noOfAC.value, "no_of_ac");
    store.UPDATE_CALCULATOR_DATA(criticalLoad.value, "backup_power");
    store.UPDATE_CALCULATOR_DATA(backupHours.value, "backup_hours");
    store.UPDATE_CALCULATOR_DATA(0, "Night");
    store.UPDATE_CALCULATOR_DATA(0, "Morning");
    console.log("generateData");
    emits("calculateData");
  } else {
    criticalLoadAndBackupHoursApiCalled.value = false;
  }
};

const appliancesContainerStyles = (row, column) => { 
  if (row.is_new) {
    return "edit_data_actions";
  }
  return "edit_data";
};

const confirmDataTable = (row, column) => {
  if (row.name == "Air Conditioner") {
    store.UPDATE_CALCULATOR_DATA(true, "ac");
  }
  if (row.name === "") {
    return;
  } else {
    const newApplicationList = appliancesList.value.filter((item) => {
      return item.label !== row.name;
    });

    appliancesList.value = newApplicationList;
    row.is_new = false;
    newAppliancesAdded.value = false;
    totalAppliancesConsumption();
    backupPower();
    workingHours();
    updateCalculatorsData();
  }
};
const updateScreenWidth = () => {
  screenWidth.value = window.innerWidth;
};

onMounted(async () => {
  window.addEventListener('resize', updateScreenWidth);
  let solarCalculatorId = calculatorData.isTata ? TEMPLATE_ID_FOR_TATA : TEMPLATE_ID_FOR_DIFF_ORG;
  await API.SOLARCALCULATOR.GET_BASIC_FORM_TEMPLATE(solarCalculatorId).then(
    (items) => {
      items.data.sections.forEach(section => {
        section.fields.sort((a, b) => a.sequence - b.sequence);
      });
      data.value = items.data;
      leadCaptureTemplate.value = items.data;
      basicInfoData.value = items.data;
    } 
  );
  totalAppliancesConsumption();
  backupPower();
  workingHours();

  if(calculatorData.offGridTabSelected){
    handleRadioChange()
  }
});
onBeforeUnmount(() => {
  window.removeEventListener('resize', updateScreenWidth);
});

watch(totalAppliancesConsumptionData, (newValue, oldValue) => {
  if (parseFloat(newValue) !== oldValue) {
    shouldCallFinancialApi.value = true;
  }
});


// watch(morning_outage, (newValue, oldValue) => {
//   if (parseInt(newValue) !== oldValue) {
//     outageHoursApiCalling.value = true;
//   }
// });

// watch(evening_outage, (newValue, oldValue) => {
//   if (parseInt(newValue) !== oldValue) {
//     outageHoursApiCalling.value = true;
//   }
// });

const handleAppliancesWatt = (row, column) => {
  if (parseInt(row.default_load_kw) > 1500) {
    row.default_load_kw = 1500;
  }

  if (parseInt(row.default_load_kw) < 0) {
    row.default_load_kw = 1;
  }
  if (parseInt(row.default_load_kw) === 0) {
    row.default_load_kw = 1;
  }

  if (
    parseInt(row.default_load_kw) < 1500 &&
    parseInt(row.default_load_kw) > 0
  ) {
    row.default_load_kw = Math.round(row.default_load_kw);
  }
  if (row.is_new === false) {
    totalAppliancesConsumption();
    backupPower();
  }
};

const handleAppliancesSelect = (row, column) => {
  const selectedValue = applicationListValueSelect.value.find(
    (item) => item.name === row[column.id]
  );
  row.name = selectedValue.name;
  row.quantity = row.quantity > 0 ? row.quantity : selectedValue.quantity;
  row.default_load_kw =  selectedValue.default_load_kw;
    // row.default_load_kw > 0
    //   ? row.default_load_kw
    //   :
  row.operating_hour =
    row.operating_hour > 0 ? row.operating_hour : selectedValue.operating_hour;

  confirmDataTable(row, column);

};

const handleTableData = (row, column) => {
  if (row.name == "Air Conditioner") {
    store.UPDATE_CALCULATOR_DATA(false, "ac");
  }

  // if(row.name == ""){
  //   return
  // }
  const newTable = tableData.value.filter((item) => {
    return item.name !== row.name;
  });
  const newAddedLabel = { label: row.name };
  if(row.name !== "" && !row.is_new ){
    appliancesList.value.push(newAddedLabel);
  }


  tableData.value = newTable;
  newAppliancesAdded.value = false;
  if (!row.is_new) {
    updateCalculatorsData();
    totalAppliancesConsumption();
    backupPower();
  }
};

// const handleMorningDecrementButton = (label, trigger) => {
//   if (
//     label === "Morning" &&
//     trigger === "decrease" &&
//     parseInt(morning_outage.value) === 0
//   ) {
//     return subsDisabledImg.value;
//   } else {
//     return subs.value;
//   }
// };

// const handleMorningIncrementButton = (label, trigger) => {
//   if (
//     label === "Morning" &&
//     trigger === "increase" &&
//     parseInt(morning_outage.value) === 5
//   ) {
//     return addDisabledImg.value;
//   } else {
//     return add.value;
//   }
// };

// const handleNightDecrementButton = (label, trigger) => {
//   if (
//     label === "Night" &&
//     trigger === "decrease" &&
//     parseInt(evening_outage.value) === 0
//   ) {
//     return subsDisabledImg.value;
//   } else {
//     return subs.value;
//   }
// };

// const handleNightIncrementButton = (label, trigger) => {
//   if (
//     label === "Night" &&
//     trigger === "increase" &&
//     parseInt(evening_outage.value) === 19
//   ) {
//     return addDisabledImg.value;
//   } else {
//     return add.value;
//   }
// };

// const handleIncrementDecrementStyles = (label, trigger) => {
//   if (
//     label === "Night" &&
//     trigger === "decrease" &&
//     evening_outage.value === 0
//   ) {
//     return "time_disabled_button";
//   }

//   if (
//     label === "Night" &&
//     trigger === "increase" &&
//     evening_outage.value === 19
//   ) {
//     return "time_disabled_button";
//   }

//   if (
//     label === "Morning" &&
//     trigger === "decrease" &&
//     morning_outage.value === 0
//   ) {
//     return "time_disabled_button";
//   }

//   if (
//     label === "Morning" &&
//     trigger === "increase" &&
//     morning_outage.value === 5
//   ) {
//     return "time_disabled_button";
//   }

//   return "time_button";
// };

const getInputStyles = (fields) => {
  switch (fields) {
    case "Mobile Number":
      if (mob_no_error.value === true) {
        return "input_error_fields";
      } else {
        return "input_fields";
      }
      break;
    case "Email":
      if (email_error.value === true) {
        return "input_error_fields";
      } else {
        return "input_fields";
      }
      break;
    case "Name":
      if (name_error.value === true) {
        return "input_error_fields";
      } else {
        return "input_fields";
      }
      break;
    default:
      return "input_fields";
      break;
  }
};

const handleRoi = async () => {
  data.value.sections[0].fields.map((item) => {
    if (item.label === "Type of Product") {
      item.additional_info.default_option = calculatorData.selected_grid;
    }

    if (item.label === "Recommended Solar Capacity") {
      item.additional_info.default_option = calculatorData.dc_size;
    }

    if (item.label === "Account Type") {
      item.additional_info.default_option = "Residential";
    }

    if (item.label === "Is your building under construction?") {
      item.additional_info.default_option = "No";
    }

    if (item.label === "Name") {
      item.additional_info.default_option = "";
      store.UPDATE_CALCULATOR_DATA("", "Name");
      name_error.value = false;
    }

    if (item.label === "Email") {
      item.additional_info.default_option = "";
      store.UPDATE_CALCULATOR_DATA("", "Email");
      email_error.value = false;
    }

    if (item.label === "Mobile Number") {
      item.additional_info.default_option = "";
      store.UPDATE_CALCULATOR_DATA(0, "Mobile Number");
      mob_no_error.value = false;
    }

    if (item.label === "Pincode") {
      item.additional_info.default_option = calculatorData.pin_code;
    }
  });
  uploadedFile.value = {};
  readAgreement.value = false;
  dialogVisible.value = !dialogVisible.value;
  data.value.sections[0].fields.forEach((item, index) => {
    if (
      item.additional_info.default_option &&
      item.additional_info.default_option !== "" &&
      item.additional_info.default_option !== 0
    ) {
      const file_upload = {
        answer: {
          additional_info: {
            financial_data: index === 0 ? calculatorData.calculated_data : "",
          },
          corners: {
            address: "",
            center: {},
            coordinates: [],
            map_image: [],
            zoom: "",
          },
          deleted_files: [],
          files: [],
          options: item.additional_info.default_option,
          sub_options: {
            question_type: "",
            value: "",
          },
          text: "",
        },
        question: item.id,
        question_type: item.question_type,
        site_survey: calculatorData.site_survey_token,
      };
      const callApi = debounce(async () => {
        await API.EDITABLE_SITE_SURVEY_API.PATCH_ANSWERS(file_upload);
      }, 1000);
      callApi();
    }
  });
};

const totalAppliancesConsumption = () => {
  if (tableData.value.length === 0) {
    totalAppliancesConsumptionData.value;
  }

  const morningTotalConsumption = tableData.value.reduce((sum, appliances) => {
    return (
      sum +
      appliances.quantity *
        appliances.default_load_kw *
        appliances.operating_hour_morning
    );
  }, 0);

  const eveningTotalConsumption = tableData.value.reduce((sum, appliances) => {
    return (
      sum +
      appliances.quantity *
        appliances.default_load_kw *
        appliances.operating_hour_evening
    );
  }, 0);

  totalAppliancesConsumptionData.value = (
    (morningTotalConsumption + eveningTotalConsumption) /
    1000
  ).toFixed(2);
  store.UPDATE_CALCULATOR_DATA(
    totalAppliancesConsumptionData.value,
    "total_consumption"
  );
  backupEnergy();
};

const backupPower = () => {
  if (tableData.value.length === 0) {
    totalAppliancesConsumptionData.value;
  }
  const totalConsumption = tableData.value.reduce((sum, appliances) => {
    return sum + appliances.quantity * appliances.default_load_kw;
  }, 0);
  totalBackupPower.value = (totalConsumption / 1000).toFixed(2);
  totalLoad.value = totalConsumption
  store.UPDATE_CALCULATOR_DATA(totalBackupPower.value, "backup_power");
  backupEnergy();
};

const backupEnergy = () => {
  if (tableData.value.length === 0) {
    totalAppliancesConsumptionData.value;
  }
  const totalBackup = totalBackupPower.value;
  const totalEveningConsumption = eveningOutageHours.value;
  const newValue =
    (totalBackup * totalEveningConsumption) / (0.85 * 0.95 * 0.95) / 0.7;
  totalBackupEnergy.value = newValue.toFixed(2);
  store.UPDATE_CALCULATOR_DATA(totalBackupEnergy.value, "backup_energy");
};

const handleButtonDisabled = () => {
  const condition = optArray.value.some((item) => item === null);

  if (condition === false && optArray.value.length === 4) {
    return false;
  } else {
    return true;
  }
};

const addAppliancesData = () => {
  const newAppliance = {
    name: "",
    quantity: 1,
    default_load_kw: 0,
    operating_hour_morning: 1,
    operating_hour_evening: 1,
    is_new: true,
    id: Date.now() // Unique ID for each new appliance
  };
  
  tableData.value.push(newAppliance);
  newAppliancesAdded.value = true;
  
  activeNames.value = [newAppliance.id];
};

const handleAppliancesDecrementButton = (row, column, trigger) => {
  if (column.id === "quantity" && row[column.id] == 0) {
    return subsDisabledImg.value;
  }
  if (row[column.id] <= 0 && trigger === "decrease") {
    return subsDisabledImg.value;
  } else {
    return subs.value;
  }
};

const handleAppliancesIncrementButton = (row, column, trigger) => {
  if (trigger === "increase") {
    if (column.id === "operating_hour_morning" && row[column.id] === 5) {
      return addDisabledImg.value;
    }
    if (column.id === "operating_hour_evening" && row[column.id] === 19) {
      return addDisabledImg.value;
    }
    if (column.id === "quantity" && row[column.id] === 99) {
      return addDisabledImg.value;
    }
    return add.value;
  }
};

const handleAppliancesButtonStyles = (row, column, trigger) => {
  if (column.id === "quantity" && row[column.id] == 0 && trigger == "decrease") {
    return "time_disabled_button";
  }

  if (column.id === "quantity" && row[column.id] == 99 && trigger == "increase") {
    return "time_disabled_button";
  }
  if (row[column.id] <= 0 && trigger === "decrease") {
    return "time_disabled_button";
  }
  if (
    column.id === "operating_hour_morning" &&
    row[column.id] === 5 &&
    trigger === "increase"
  ) {
    return "time_disabled_button";
  }
  if (
    column.id === "operating_hour_evening" &&
    row[column.id] === 19 &&
    trigger === "increase"
  ) {
    return "time_disabled_button";
  }
  return "time_button";
};

const handleAppliancesButtonInput = (row, column) => {
  if (row.operating_hour_morning > 5) {
    row.operating_hour_morning = 5;
  }

  if (row.operating_hour_morning == null) {
  }
  if (row.operating_hour_morning < 0) {
    row.operating_hour_morning = Math.abs(row.operating_hour_morning);
  }

  if (row.operating_hour_evening > 19) {
    row.operating_hour_evening = 19;
  }

  if (row.operating_hour_evening < 0) {
    row.operating_hour_evening = 0;
  }

  if (row.operating_hour_morning < 5 && row.operating_hour_morning == 1) {
    row.operating_hour_morning = Math.round(row.operating_hour_morning);
  }

  if (row.operating_hour_evening < 19 && row.operating_hour_evening == 1) {
    row.operating_hour_evening = Math.round(row.operating_hour_evening);
  }

  if (row.quantity > 99) {
    row.quantity = 99;
  }
  if (row.quantity < 0) {
    row.quantity = 1;
  }

  if (row.quantity < 999 && row.quantity > 0) {
    row.quantity = Math.round(row.quantity);
  }

  if (row.quantity === 0) {
    row.quantity = 1;
  }

  if (row.quantity !== "" && row.is_new === false) {
    totalAppliancesConsumption();
    backupPower();
    workingHours();
  }
};

const handleAppliancesButtonBlur = (row, column) => {
  row.operating_hour_evening = Math.round(row.operating_hour_evening);
  row.operating_hour_morning = Math.round(row.operating_hour_morning);
  if (row.operating_hour_evening === "" || row.operating_hour_evening < 0) {
    row.operating_hour_evening = 0;
  }

  if (row.operating_hour_morning === "" || row.operating_hour_evening < 0) {
    row.operating_hour_morning = 0;
  }

  if (row.quantity === "") {
    row.quantity = 1;
  }

  if (row.is_new === false && shouldCallFinancialApi.value === true) {
    emits("calculateData");
    totalAppliancesConsumption();
    backupPower();
    workingHours();
    shouldCallFinancialApi.value = false;
    if(calculatorData.isTata && eveningOutageHours.value > 7){      
      ElMessage({
            message: 'The appliance you have added exceeds the maximum supported backup hours. Please adjust your selection to stay within the supported limits for accurate backup hour calculations.',
            type: 'info',
          })
    }
  }
};

const recalculateTableData = (row) => {
  if (row.is_new === false && shouldCallFinancialApi.value === true) {
    emits("calculateData");
    shouldCallFinancialApi.value = false;
  }
};

const handleAppliancesClicks = (row, column, trigger) => {
  shouldCallFinancialApi.value = false;
  if (trigger === "decrease") {
    if (column.id === "quantity" && row[column.id] == 0) {
      return;
    }
    if (row[column.id] == 0 && column.id !== "quantity") {
      return;
    }
    row[column.id] -= 1;
  }
  if (trigger === "increase") {
    if (column.id === "operating_hour" && row[column.id] === 24) {
      return;
    }

    if (column.id === "quantity" && row[column.id] === 99) {
      return;
    }

    if (column.id === "operating_hour_morning" && row[column.id] === 5) {
      return;
    }

    if (column.id === "operating_hour_evening" && row[column.id] === 19) {
      return;
    }
    row[column.id] += 1;
  }

  if (row.is_new === false) {
    workingHours();
    totalAppliancesConsumption();
    backupPower();
    updateCalculatorsData();
  }
};

const workingHours = () => {
  if (tableData.value.length === 0) {
    return;
  }

  const totalWattage = tableData.value.reduce((sum, appliances) => {
    return sum + appliances.quantity * appliances.default_load_kw;
  }, 0);

  const morningEnergyConsumed = tableData.value.reduce((sum, appliances) => {
    return (
      sum +
      appliances.quantity *
        appliances.default_load_kw *
        appliances.operating_hour_morning
    );
  }, 0);

  const eveningEnergyConsumed = tableData.value.reduce((sum, appliances) => {
    return (
      sum +
      appliances.quantity *
        appliances.default_load_kw *
        appliances.operating_hour_evening
    );
  }, 0);
  eveningOutageHours.value = eveningEnergyConsumed / totalWattage;
  const morningTotalEnergy = morningEnergyConsumed / 1000;
  const eveningTotalEnergy = eveningEnergyConsumed / 1000;
  store.UPDATE_CALCULATOR_DATA(morningTotalEnergy, "Morning");
  store.UPDATE_CALCULATOR_DATA(eveningTotalEnergy, "Night");
  if(eveningOutageHours.value > 7){
    store.UPDATE_CALCULATOR_DATA(7 , "backup_hours");
  }else{
    store.UPDATE_CALCULATOR_DATA(eveningOutageHours.value , "backup_hours");
  }
  backupEnergy();
};

const updateData = () => {
  emits("calculateData");
};

const updateCalculatorsData = debounce(() => {
  emits("calculateData");
}, 1000);

// const handleTime = (label, method) => {
//   switch (label) {
//     case "Morning":
//       if (method === "decrease") {
//         if (morning_outage.value > 0) {
//           morning_outage.value = parseInt(morning_outage.value) - 1;
//           updateCalculatorsData();
//           store.UPDATE_CALCULATOR_DATA(parseInt(morning_outage.value), label);
//         }
//       }

//       if (method === "increase" && morning_outage.value < 5) {
//         morning_outage.value = parseInt(morning_outage.value) + 1;
//         updateCalculatorsData();
//         store.UPDATE_CALCULATOR_DATA(parseInt(morning_outage.value), label);
//       }

//       break;
//     case "Night":
//       if (method === "decrease") {
//         if (evening_outage.value > 0) {
//           evening_outage.value = parseInt(evening_outage.value) - 1;
//           updateCalculatorsData();
//           store.UPDATE_CALCULATOR_DATA(parseInt(evening_outage.value), label);
//         }
//       }
//       if (method === "increase" && evening_outage.value < 19) {
//         evening_outage.value = parseInt(evening_outage.value) + 1;
//         updateCalculatorsData();
//         store.UPDATE_CALCULATOR_DATA(parseInt(evening_outage.value), label);
//       }
//       backupEnergy();
//       break;

//     default:
//       break;
//   }
// };

const buttonDisabled = () => {
const validation = calculatorData.account_type == "Company/Society/Institution" && calculatorData.required_customer_field == "" 
  if (
    calculatorData.name !== "" &&
    calculatorData.email !== "" &&
    calculatorData.mobile_no !== 0 &&
    readAgreement.value === true &&
    !validation&&
    mob_no_error.value !== true &&
    email_error.value !== true &&
    name_error.value !== true
  ) {
    return false;
  } else {
    return true;
  }
};

const buttonStyles = () => {
  const validation = calculatorData.account_type == "Company/Society/Institution" && calculatorData.required_customer_field == "" 
  if (
    calculatorData.name !== "" &&
    calculatorData.email !== null &&
    calculatorData.mobile_no !== 0 &&
    readAgreement.value === true &&
    !validation&&
    mob_no_error.value !== true &&
    email_error.value !== true &&
    name_error.value !== true
  ) {
    return "moreDetailsButton";
  } else {
    return "button_disabled";
  }
};

const verifyDetails = async () => {
  loading.value = true;
  const send_otp_data = {
    phone: `91${calculatorData.mobile_no}`,
    org:263,
  };

  try {
    await API.SOLARCALCULATOR.SEND_OTP(send_otp_data);
    dialogVisible.value = !dialogVisible.value;
    verificationDialog.value = true;
    setTimerValue();
    ElMessage({
      showClose: true,
      message: "OTP sent",
      type: "success",
      center: true,
    });
    optArray.value = [];
  } catch (err) {
    ElMessage({
      showClose: true,
      message:
        err.response.data === "Invalid Number"
          ? "Input valid mobile number"
          : "Unable to send OTP",
      type: "error",
      center: true,
    });
  }

  loading.value = false;
};

const isMobile = computed(() => screenWidth.value < 1180);
</script>

<style scoped>
.main_outage_form {
  display: flex;
  gap: 10px;
}

.wrapper_outage_form {
  margin-top: 10px;
  display: flex;
  align-items: center;
  padding: 5px;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  flex: 1;
  height: 10vh;
}

.powerCard {
  flex: 1;
  display: flex;
  height: 64px;
  padding: 10px 16px;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border-radius: 8px;
  background: var(--White, #fff);
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.15);
}

.blueButton {
  padding-top: 10px;
  padding-bottom: 10px;
  background-color: #006eaf;
  border: none;
  outline: none;
  color: var(--grey-grey-100, var(--White, #fff));
  font-family: Arial;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  cursor: pointer;
  width: 100%;
  margin-top: 8px;
}

.right {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-left: 10px;
}

.blueContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #006eaf;
  margin-top: 10px;
  border-radius: 8px;
}

.dialogCustom {
  position: relative;
  height: 100%;
}

.dialogVerification >>> .el-dialog__header {
  background-color: #e8edf2;
  margin-right: 0;
  border-radius: 8px 8px 0px 0px;
}

.dialogCustom >>> .el-dialog__header {
  background-color: #e8edf2;
  margin-right: 0;
  border-radius: 10px 10px 0px 0px;
  padding: 0;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 15px;
  padding-bottom: 15px;
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 999;
}

.dialogVerification >>> .el-dialog__header {
  background-color: #e8edf2;
  margin-right: 0;
  border-radius: 10px 10px 0px 0px;
  padding: 0;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 15px;
  padding-bottom: 15px;

  position: sticky;
}

.slider_inner_button {
  background-color: black;
  color: white;
  border: none;
  margin-bottom: 1px;
  cursor: pointer;
}

.slider_inner_disable_button {
  background-color: #ccc;
  color: white;
  border: none;
  margin-bottom: 2px;
  cursor: not-allowed;
}

.dialogCustom >>> .el-checkbox__inner {
  z-index: 0;
}

.dialogCustom >>> .el-checkbox__inner {
  z-index: 0;
}

.dialogCustom >>> .el-checkbox__input {
  background-color: yellow;
}

.dialogVerification >>> .el-dialog__body {
  padding: 16px;
  color: black;
}

.dialogCustom >>> .el-dialog__body {
  padding: 0px;
  color: black;
}

.moreDetailsButton {
  width: 100%;
  border: none;
  outline: none;
  background-color: var(--Primary-Tata, #006eaf);
  height: 30px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 700;
  font-size: 16px;
  color: white;
  padding: 20px;
  z-index: 999;
}

.button_disabled {
  width: 100%;
  border: none;
  height: 30px;
  background-color: #e8edf2;
  outline: none;
  color: #ccc;
  padding: 20px;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  border-radius: 8px;
  cursor: not-allowed;
}

.loading_popup >>> .el-dialog__headerbtn {
  display: none;
}

.loading_popup >>> .el-dialog__header {
  display: none;
}

.loading_popup :deep() .el-dialog {
  padding: 0px;
  border-radius: 8px;
}

.productTypes {
  margin-top: 10px;
}

.cards {
  margin-top: 10px;
  height: 20vh;
  /* background-color: #006eaf; */
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
}

.cardWrapper {
  color: black;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  justify-content: center;
}

.contact_right {
    display:flex;
    flex-direction: column;
    text-align: left;
    gap: 4px;
  }

.input_containers {
  margin-top: 10px;
}

.input_containers :deep() .el-input__inner {
  color: black;
  font-size: 16px;
}
.logo_card {
  margin-top: 10px;
  border-radius: 8px;
  padding: 10px;
  border: 1px solid #cccccc;
}
.input_fields {
  margin-top: 5px;
  color: black;
}

.input_error_fields {
  margin-top: 5px;
  color: black;
}

.input_fields >>> .el-input.is-disabled .el-input__inner {
  color: #2c2727; /* Change this color to your desired text color */
}

.input_error_fields >>> .el-input.is-disabled .el-input__inner {
  color: #2c2727; /* Change this color to your desired text color */
}

.input_capacity {
  display: flex;
  height: 48px;
  padding: 10px 16px;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border: none;
  background: var(--White, #fff);
  border-radius: 8px;
  border: 1px solid var(--Grey-CCC, #ccc);
  box-shadow: 0 0 0 1px var(--el-input-border-color, var(--el-border-color))
    inset;
  margin-top: 5px;
}

.input_capacity >>> .el-input-group__append {
  box-shadow: none;
  background-color: white;
}
.input_fields >>> .el-input__wrapper {
  display: flex;
  height: 48px;
  padding: 10px 16px;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid var(--Grey-CCC, #ccc);
  background: var(--White, #fff);
}

.input_error_fields >>> .el-input__wrapper {
  display: flex;
  height: 48px;
  padding: 10px 16px;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid var(--Grey-CCC, red);
  background: var(--White, #fff);
}

.is_focus {
  outline: none;
  border: none;
}

.mainPowerContainer {
  margin-top: 10px;
  border: 1px solid var(--CCC, #ccc);
  padding: 10px;
  border-radius: 5px;
}

.pinInputContainer {
  display: flex;
  gap: 20px;
}

.pinInput {
  width: 50px;
  text-align: center;
  border-radius: 2px;
  border: none;
  border-bottom: 1px solid grey;
  outline: none;
  font-size: 18px;
  padding: 5px;
}

.PDcard {
  padding: 16px 10px;
  border-radius: 4px;
  background-color: #e8edf2;
  text-align: center;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 120px;
  height: 120px;
  border: 1px dashed var(--999, #999);
  gap: 8px;
  cursor: pointer;
  align-self: center;
}

.productTypes >>> .el-radio__input.is-checked + .el-radio__label {
  color: black;
}

.productTypes >>> .el-radio__input.is-checked .el-radio__inner {
  border-color: #006eaf;
  background-color: white;
  border: 2px solid #006eaf;
}

.number_input >>> .el-input-number__decrease {
  border-radius: 50%;
  background-color: #0d0d0d;
  color: white;
  font-size: 14px;
  width: 30px;
  height: 30px;
}

.Verification {
  position: sticky;
  bottom: 0;
  background: var(--White, #fff);
  box-shadow: 4px 0px 10px 0px rgba(0, 0, 0, 0.25);
  width: 100%;
  padding: 10px;
}

.fixed-header {
  position: sticky;
  top: 0;
}

.veri_button {
  background: var(--White, #fff);
  width: 100%;
  padding-top: 30px;
  padding-left: 30px;
  padding-right: 30px;
  padding-bottom: 15px;
  display: flex;
  align-items: center;
}

.number_input >>> .el-input-number__increase {
  border-radius: 50%;
  background-color: #0d0d0d;
  color: white;
  height: 30px;
  width: 30px;
  font-size: 14px;
}

.time_input {
  border-radius: 4px;
  border: 1px solid var(--999, #999);
  background: var(--White, #fff);
  width: 60px;
  padding: 5px;
  display: flex;
  align-items: center;
  cursor: not-allowed;
}

.appliances_input {
  border-radius: 8px;
  border: 1px solid var(--CCC, #ccc);
  background: var(--White, #fff);
  width: 75px;
  padding: 5px;
  display: flex;
  align-items: center;
  height: 35px;
}

.time_button {
  cursor: pointer;
}

.appliances_time_button {
  height: 22px;
  width: 22px;
  border: none;
  border-radius: 50%;
  color: white;
  background-color: #006eaf;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.time_disabled_button {
  /* height: 22px;
  width: 22px;
  border-radius: 50%;
  border: none;
  color: white;
  background-color: #ccc;
  display: flex;
  align-items: center;
  justify-content: center; */
  cursor: not-allowed;
}

.appliances_time_disabled_button {
  cursor: not-allowed;
}

.time_input >>> input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.watt_appliances >>> input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.input_fields >>> input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.input_error_fields >>> input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.input_fields >>> input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.number_input >>> .el-input__inner {
  border: 1px;
  box-shadow: 0 0 0 1px var(--el-input-border-color, var(--el-border-color))
    inset;
}

.number_input >>> .el-input__wrapper {
  box-shadow: none;
}

.productTypes >>> .el-radio__inner::after {
  height: 6px;
  width: 5.5px;
  background-color: #006eaf;
  top: 50%;
  left: 50%;
}

.radio_container {
  margin-top: 24px;
}

.radio_container >>> .el-radio__inner {
  height: 24px;
  width: 24px;
  border: 1px solid #999;
}

.radio_container >>> .el-radio__input.is-checked .el-radio__inner {
  background-color: #1C3366;
}

.radio_container >>> .el-radio__inner:after {
  width: 8px;
  height: 8px;
}

.radio_container >>> .el-radio__label {
  color: 222;
  font-size: 16px;
}

.radio_container >>> .el-radio__input.is-checked+.el-radio__label {
  color: #1C3366;
  font-weight: bold;
}

.gridContainer {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-top: 24px;
}

.flexColumn {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none !important;
  margin: 0 !important;
}

.criticalLoadUnit {
  position: absolute;
  right: 16px;
  top: 40px;
}

.input_label {
  font-size: 14px;
  font-weight: 600;
  color: #222;
}

.input_fields {
  font-size: 16px;
  color: #777;
  height: 48px;
  padding: 12px;
  border-radius: 4px;
  border: 1px solid var(--Grey-Scale-999, #999);
  background: var(--Grey-Scale-White, #FFF);
}

.gridContainer >>> .el-select {
  margin-top: 5px;
  width: 100%;
}

.gridContainer >>> .el-select__wrapper {
  border: 1px solid var(--Grey-Scale-999, #999);
  background: var(--Grey-Scale-White, #FFF);
  height: 48px;
  box-shadow: none;
}

.requiredClass {
  color: red;
}

.dropdownContainer {
  width: 100%;
}

.dropdownContainer >>> .el-select .el-input__wrapper {
  display: flex;
  height: 48px;
  width: 100%;
  padding: 10px 12px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid var(--Grey-CCC, #ccc);
  background: var(--White, #fff);
}

.appliances_number_input :deep() .el-input-number__decrease {
  border-radius: 50%;
  background-color: #006eaf;
  color: #fff;
  height: 50%;
  top: 25%;
  width: 13%;
}

.appliances_number_input :deep() .el-input-number__increase {
  border-radius: 50%;
  background-color: #006eaf;
  color: #fff;
  height: 50%;
  top: 25%;
  width: 13%;
  right: 19%;
}

.appliances_number_input :deep() .el-input__wrapper {
  box-shadow: none;
}

.appliances_number_input :deep() .el-input__inner {
  height: 35px;
  box-shadow: 0 0 0 1px var(--el-input-border-color, var(--el-border-color))
    inset;
  border-radius: 8px;
  position: relative;
  left: -22%;
}

.watt_appliances :deep() .el-input__wrapper {
  width: 90px;
  border-radius: 8px;
  border: 1px solid var(--CCC, #ccc);
  background: var(--White, #fff);
  box-shadow: none;
}

.productTypes >>> .el-select .el-input__wrapper {
  display: flex;
  height: 48px;
  padding: 10px 12px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid var(--Grey-CCC, #ccc);
  background: var(--White, #fff);
  margin-top: 10px;
}

.error_field {
  margin-top: 5px;
  color: red;
  font-size: 12px;
}

.dialogCustom >>> .el-dialog {
  overflow: scroll;
  border-radius: 10px;
  position: relative;
}

.dialogVerification >>> .el-dialog {
  border-radius: 10px;
}

.input_time {
  outline: none;
  border: none;
  width: 20px;
  cursor: not-allowed;
}

.appliances_input_value {
  outline: none;
  border: none;
  width: 100%;
}

.appliances_watt_value {
  width: 75px;
  border-radius: 8px;
  border: 1px solid var(--Grey-CCC, #ccc);
  background: var(--White, #fff);
  height: 35px;
  padding: 5px;
  outline: none;
}
.time_container {
  margin-top: 10px;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid var(--Grey-CCC, #ccc);
  background: var(--White, #fff);
}

.input_number {
  display: flex;
  align-items: center;
  gap: 10px;
}

.check_box {
  margin-top: 10px;
  padding-left: 20px;
  margin-bottom: 10px;
}

.check_box >>> .el-checkbox__input.is-checked + .el-checkbox__label {
  color: black;
}

.dialog_title {
  color: var(--222, #222);
  font-family: Arial;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.error_dialog_title {
  color: red;
  font-family: Arial;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.unit_text {
  color: var(--Grey-777, var(--777, #777));
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.img_container {
  position: relative;
  box-shadow: 0 0 0 1px var(--el-input-border-color, var(--el-border-color))
    inset;
  margin-top: 10px;
  border-radius: 8px;
  display: flex;
  width: 120px;
  height: 120px;
  padding: 12px;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
  align-items: center;
  background: var(--Background, #e8edf2);
}

.el-message.is-closable .el-message__content {
  z-index: 9999;
}

.delete-button {
  display: none;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.verifyHeader {
  color: #000;
  text-align: center;
  font-family: Arial;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.info_note {
  color: var(--Grey-777, var(--777, #777));
  font-family: Arial;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-top: 10px;
}

.dialogCustom >>> .el-dialog {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* Internet Explorer */
  border-radius: 8px;
}

.upload-demo >>> .el-upload-dragger {
  display: flex;
  width: 120px;
  height: 120px;
  padding: 12px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 8px;
  border: 1px dashed var(--Grey-777, #777);
  background: var(--White, #fff);
}

.capacity_input {
  border: none;
  outline: none;
  background-color: white;
  color: black;
  font-size: 16px;
}

.capacity_input:hover {
  cursor: no-drop;
}

.input_capacity:hover {
  cursor: no-drop;
}

.otp_not_received {
  color: var(--777, #777);
  text-align: center;
  font-family: Arial;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.verify_received {
  color: var(--White, #fff);
  font-family: Arial;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.file_input {
  height: 100%;
  width: 100%;
  display: none;
}

.otp_send {
  color: #000;
  text-align: center;
  font-family: Arial;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration-line: underline;
  cursor: pointer;
}

.otp_send_disabled {
  color: #ccc;
  text-align: center;
  font-family: Arial;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration-line: underline;
  cursor: not-allowed;
}

.input_field_error >>> .el-input__wrapper {
  display: flex;
  height: 48px;
  padding: 10px 16px;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid var(--Grey-CCC, #ef1212);
  background: var(--White, #fff);
}

.file_upload_card {
  display: flex;
  width: 120px;
  height: 120px;
  padding: 12px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 8px;
  border: 1px dashed var(--Grey-777, #777);
  background: var(--White, #fff);
  margin-top: 10px;
  cursor: pointer;
}

.custom-checkbox >>> .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #006eaf;
  border: #006eaf;
}

.custom-checkbox :deep() .el-checkbox__inner::after {
  left: 5px;
  top: 2px;
}

.details_card {
  padding: 10px;
  margin-top: 24px;
  background-color: var(--777, #edf1f5);
  border-radius: 8px;
  box-shadow: 0 0 0 1px var(--el-input-border-color, var(--el-border-color))
    inset;
}

.contact_details,
.contact_details2 {
  font-weight: bold;
  font-size: 14px;
  line-height: 18px;
  color: #006eaf;
}

.contact_details2 {
  color: #1C3366;
}

.contact_info {
  font-size: 14px;
  line-height: 18px;
  font-weight: bold;
}

.contact_wrapper {
  display: flex;
  align-items: center;
  padding: 10px;
  gap: 10px;
}

.note {
  color: var(--Grey-777, var(--777, #777));
  font-family: Arial;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.dialogCustom >>> .el-dialog__headerbtn {
  display: none;
}

.dialogVerification >>> .el-dialog__headerbtn {
  display: none;
}

.dialogCustom >>> .el-dialog::-webkit-scrollbar {
  display: none; /* Webkit (Chrome, Safari, etc.) */
}
.input_fields >>> .el-input-number__decrease {
  display: none;
}

.input_error_fields >>> .el-input-number__decrease {
  display: none;
}

.appliances_details_container {
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 13px;
}

.main_appliances_container {
  border-radius: 8px;
  border: 1px solid #ccc;
  background: #fff;
  padding: 16px;
  display: flex;
  gap: 10px;
  flex-direction: column;
  margin-top: 15px;
}

.appliances_title {
  margin-top: 24px;
  margin-bottom: 12px;
  color: var(--777, #777);
  font-family: Arial;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.appliances_add_button {
  display: flex;
  align-items: center;
  justify-content: end;
}

.appliances_button {
  border: none;
  background-color: white;
  color: #184d93;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 26px; /* 162.5% */
  cursor: pointer;
}

.appliances_details {
  color: var(--777, #777);
  font-family: Arial;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.hrClass {
  border-top: 2px solid #cccccc;
}

.appliances_values {
  color: #000;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.appliances_names {
  color: var(--Black, var(--222, #222));
  font-family: Arial;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.appliances_table {
  display: flex;
  padding: 0px 16px;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid var(--CCC, #ccc);
}

.appliances_input >>> input[type="number"]::-webkit-inner-spin-button,
.appliances_input input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
  color: red;
}

.input_time >>> input[type="number"]::-webkit-inner-spin-button,
.input_time input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
  color: red;
}

.my-header {
  color: #000;
  font-family: Arial;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.edit_data {
  margin-left: 90%;
  display: flex;
  align-items: center;
  gap: 10px;
}

.edit_data_actions {
  margin-left: 90%;
  display: flex;
  align-items: center;
  gap: 10px;
}

@media (max-width: 827px) {
  .dialogCustom >>> .el-dialog {
    width: 90%;
    -ms-overflow-style: none;
  }
}

@media (max-width: 1180px) {
  .dialogCustom >>> .el-dialog {
    width: 90%;
    -ms-overflow-style: none;
  }

  .loading_popup :deep() .el-dialog {
    padding: 0px;
    border-radius: 8px;
    width: 90%;
  }
  .dialogVerification >>> .el-dialog {
    width: 90%;
  }

  .main_appliances_container {
    padding: 8px;
  }

  .hours_card {
    flex-direction: column;
  }

  .time_container {
    width: 100%;
  }

  .right {
    margin-left: 20px;
  }
}

@media (max-width: 740px) {
  .time_container {
    width: 100%;
  }
  .hours_card {
    flex-direction: column;
  }

  .gridContainer {
    grid-template-columns: 1fr;
    gap: 16px;
  }
}
.collaps-content{
  display:flex;
  flex-direction: row;
  padding-top:16px;
  width: 100%;

}

.collaps-content-label{
  flex:0.5;
}
.collaps-content-value{
  flex:0.5;
  display: flex;
  justify-content: flex-end;
}
.collaps-content-name{
  flex:0.5;
  display: flex;
}
.collapse_container>>>.el-collapse-item__content{
  padding-bottom:0px

}
.btn_container{
  display: flex;
  justify-content: flex-end;
}

@media (max-width: 600px) {

  .hrClass {
    display: none;
  }

  .appliances_title {
    margin-top: 16px;
    margin-bottom: 10px;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  .main_appliances_container {
    margin-top: 0;
    padding: 16px;
  }

  .appliances_details {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }

  .collapse_container >>> .el-collapse {
    display: flex;
    flex-direction: column;
    gap:8px;
  }

  .collapse_container >>> .el-collapse-item {
    border: 1px solid #ccc;
    border-radius: 4px;
  }

  .collapse_container >>> .el-collapse-item__header {
    border: none;
    border-radius: 4px;
  }

  .collapse_container >>> .el-collapse-item__wrap {
    padding: 0px 16px;
  }

  .collapse_container >>> .el-collapse-item__content {
    display: flex;
    flex-direction: column;
    gap:16px;
  }

  .collaps-content-name {
    flex:1;
    display: block;
  }

  .collapse_container >>> .el-select__wrapper {
    min-height: 40px;
  }

  .collaps-content {
    padding-top: 0;
  }

  .details_card {
    padding: 16px;
  }

  .cardWrapper {
    text-align: center;
  }

  .contact_info {
    padding-bottom: 24px;
    border-bottom: 1px solid #ccc;
  }
}
</style>
